/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import styles from './ConsumptionView.module.css';
import { Section, Header } from 'components';
import { ToastMessage } from 'containers';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ConsumptionFilters from './ConsumptionFilters';
import { ConsumptionFilter, FormattedConsumptionData, FormattedConsumptionTable, Location, LocationType } from 'model';
import { ListView } from 'model/state';
import { ConsumptionCard } from "./ConsumptionCard";
import { ConsumptionTable } from "./ConsumptionTable";
import moment from "moment-timezone";

type ConsumptionViewProps = {
  fetchUserLocations:         (userId: string, types?: LocationType[], page?: number, search?: string) => void,
  userId?:                    string | null,
  userLocations:              ListView<Location>,
  filters:                    ConsumptionFilter,
  updateConsumptionFilters:   (filters: Partial<ConsumptionFilter>) => void,
  consumptionData:            FormattedConsumptionData,
  fetchConsumptionByFilters:  (filters: ConsumptionFilter, timezone: string, userId?: string) => void,
  cleanConsumptionData:       () => void,
  refreshDisabled:            boolean,
  tableData:                  FormattedConsumptionTable,
  isLoading:                  boolean,
  timezone:                   string,
}

export const ConsumptionView: React.FC<ConsumptionViewProps> = React.memo(({
  fetchUserLocations,
  userLocations,
  userId,
  filters,
  updateConsumptionFilters,
  consumptionData,
  fetchConsumptionByFilters,
  refreshDisabled,
  cleanConsumptionData,
  tableData,
  isLoading,
  timezone,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (userId) {
      fetchUserLocations(userId);
      fetchConsumptionByFilters(filters, moment.tz.guess(), userId);
    }
  }, [userId]);

  useEffect(() => {
    return function cleanup() {
      cleanConsumptionData();
    };
  }, []);

  return (
    <Section>
      <ToastMessage />
      <Header className={styles.header} noBackground>
        <Col xs="12" className="col-lg-12"><h2>{t('water-usage')}</h2></Col>
      </Header>
      <Row>
        <Col xs="12">
          <ConsumptionFilters
            userLocations             = {userLocations}
            fetchUserLocations        = {fetchUserLocations}
            userId                    = {userId}
            filters                   = {filters}
            updateConsumptionFilters  = {updateConsumptionFilters}
            refreshDisabled           = {refreshDisabled}
            onRefresh                 = {fetchConsumptionByFilters}
          />
        </Col>
      </Row>
      <Row className={styles.chartContainer}>
        <Col xs="12" className="pl-0 pr-0">
          <ConsumptionCard
            consumptionData = {consumptionData}
            isLoading       = {isLoading}
            timezone        = {timezone}
          />
        </Col>
      </Row>
      <Row>
        <Col xs="12" className="pl-0 pr-0">
          <ConsumptionTable tableData={tableData} />
        </Col>
      </Row>
    </Section>
  );
});

export default ConsumptionView;
